import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import '@/styles/pages.css';

export default function WaitlistPage() {
  const { user, loading, refresh } = useAuth();

  useEffect(() => {
    refresh();
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <span>Loading...</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (user.plan !== 'waitlist') {
    return <Navigate to="/account" replace />;
  }

  return (
    <div className="centered-page">
      <div className="centered-card" style={{ maxWidth: 480, textAlign: 'center' }}>
        <div className="card-icon">
          <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <h1>You're on the Waitlist!</h1>
        <p className="card-subtitle" style={{ marginBottom: 24, lineHeight: 1.7 }}>
          Thanks for signing up. We'll notify you when your account is ready.
          You'll receive an activation link via email once a spot opens up.
        </p>
        <a href="/auth/logout" className="btn btn-ghost" style={{ width: '100%' }}>
          Sign Out
        </a>
      </div>
    </div>
  );
}
